// extracted by mini-css-extract-plugin
export default {"background":"Modal_background__jGM5T","modal":"Modal_modal__YwX8Y","action":"Modal_action__tPzbJ","body":"Modal_body__GY4sh"};